import './uclear.scss'
import './styles/style.scss'
import './bootstrap'

import NProgress from 'nprogress'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Vuebar from 'vuebar'
import VueClipboard from 'vue-clipboard2'
import VueMeta from 'vue-meta'
import VueToasted from 'vue-toasted'

import App from './App.vue'
import SectionTitle from './components/SectionTitle'
import VTrack from './components/VTrack'
import { scrollee } from './directives/scrollee'
import router from './router'
import { store } from './stores'
import './registerServiceWorker'

Vue.use(VueAnalytics, {
    id: 'UA-87966441-1',
    autoTracking: {
        page: false
    },
    debug: {
        enabled: process.env.NODE_ENV !== 'production',
        sendHitTask: process.env.NODE_ENV === 'production'
    },
    router
})
Vue.use(Vuebar)
Vue.use(VueClipboard)
Vue.use(VueMeta)
Vue.use(VueToasted)
Vue.component(SectionTitle.name, SectionTitle)
Vue.component('v-track', VTrack)
Vue.directive('scrollee', scrollee)
Vue.filter('bgstyle', value => value ? { backgroundImage: `url(${value})`} : undefined)
Vue.filter('httpfy', value => value.indexOf('http') >= 0 ? value : `http://${value}`)
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

NProgress.configure({
    minimum: 0.27,
    trickleSpeed: 800,
    showSpinner: false
})
